import { useInitData } from '../../../hooks'
import { BirdviewSkeletonLayout } from '../BirdviewSkeletonLayout'

import { useBirdviewOversightWidgets } from './BirdviewOversight.hooks'
import { getBirdviewOversightLayout } from './BirdviewOversight.utils'

function BirdviewOversight({
  activityDoneById,
  pendingIds,
  requestActions,
  scope,
  sections,
  storageScope,
  onActivityToggle,
  onNavigate,
}) {
  const { sections: sectionsPermissions } = useInitData()

  const { tiles, widgets, widgetTitles } = useBirdviewOversightWidgets({
    activityDoneById,
    pendingIds,
    requestActions,
    scope,
    sections,
    onActivityToggle,
    onNavigate,
  })

  return (
    <BirdviewSkeletonLayout
      defaultLayout={getBirdviewOversightLayout(sectionsPermissions)}
      storageScope={storageScope}
      tiles={tiles}
      widgets={widgets}
      widgetTitles={widgetTitles}
      onNavigate={onNavigate}
    />
  )
}

export default BirdviewOversight
